import { moveToFulfilled, moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  ClientSharePointWebLinkAttachmentDestroyAction,
  ClientSharePointWebLinkAttachmentPreviewLoadFulfilledAction,
  ClientSharePointWebLinkAttachmentPreviewLoadPendingAction,
  ClientSharePointWebLinkAttachmentPreviewLoadRejectedAction,
} from '../../domains/resolveClientSharePointWebLink/actions.types';

import { ClientSharePointWebLinkPreviews } from './types';

export type ClientSharePointWebLinkAction =
  | ClientSharePointWebLinkAttachmentPreviewLoadFulfilledAction
  | ClientSharePointWebLinkAttachmentPreviewLoadPendingAction
  | ClientSharePointWebLinkAttachmentPreviewLoadRejectedAction
  | ClientSharePointWebLinkAttachmentDestroyAction;

const initialState: ClientSharePointWebLinkPreviews = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const destroyClientSharePointWebLink = (state: ClientSharePointWebLinkPreviews, webLinkId: string) =>
  remove(state, [webLinkId]);

const reducer: Reducer<ClientSharePointWebLinkPreviews, ClientSharePointWebLinkAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'SHAREPOINT_WEBLINK_PREVIEW.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.clientSharePointWebLink.id], action.payload.error);
    case 'SHAREPOINT_WEBLINK_PREVIEW.LOAD_PENDING':
      return moveToPending(state, [action.payload.clientSharePointWebLink.id]);
    case 'SHAREPOINT_WEBLINK_PREVIEW.LOAD_FULFILLED':
      return moveToFulfilled(state, {
        [action.payload.clientSharePointWebLink.id]: action.payload.clientSharePointWebLink,
      });
    case 'SHAREPOINT_WEBLINK.DESTROY':
      return destroyClientSharePointWebLink(state, action.payload.clientSharePointWebLinkId);
    default:
      return state;
  }
};

export default reducer;
